import { IndividualGoalType } from "./IndividualGoal";
import filterIcon from "../images/filter-icon.svg";
import { useEffect, useRef, useState } from "react";
import '../styles/GoalMenu.css'

interface FilterGoalButtonProps {
    goalList: IndividualGoalType[];
    filterGoalList: IndividualGoalType[];
    setFilterGoalList: React.Dispatch<React.SetStateAction<IndividualGoalType[]>>;
    isScholarship?: boolean;
}

interface FilterGoalProps {
    goalCheckedList: {
        id: number;
        goal: string;
        isChecked: boolean;
    }[];
    setGoalCheckedList: React.Dispatch<React.SetStateAction<{
        id: number;
        goal: string;
        isChecked: boolean;
    }[]>>;
    filterGoalList: IndividualGoalType[];
    handleApply: () => void;
    handleCancel: () => void;
    isScholarship?: boolean;
}

interface GoalCheckedType {
    id: number;
    goal: string;
    isChecked: boolean;
}

export default function FilterGoalButton({ goalList, filterGoalList, setFilterGoalList, isScholarship }: FilterGoalButtonProps) {

    const [showFilterGoal, setShowFilterGoal] = useState(false)

    const [goalCheckedList, setGoalCheckedList] = useState<GoalCheckedType[]>([])

    useEffect(() => {
        const itemKey = isScholarship ? `scholarship_goal_checked_list` : `individual_goal_checked_list`
        const filterConfig = JSON.parse(localStorage.getItem(itemKey) || "[]") as GoalCheckedType[]

        setFilterGoalList(goalList?.filter((goal) => {
            return filterConfig?.find((config) => {
                return config?.id === goal.id && config?.isChecked
            })
        }))

        setGoalCheckedList(goalList?.map((goal) => {
            const checkedGoal = filterConfig?.find((config) => config.id === goal.id)
            if (checkedGoal) {
                return {
                    id: goal.id,
                    goal: goal.goal || goal.name || '',
                    isChecked: checkedGoal?.isChecked
                }
            }
            return {
                id: goal.id,
                goal: goal.goal || goal.name || '',
                isChecked: true
            }
        }))

    }, [goalList, showFilterGoal])

    const handleClickFilterGoal = () => {
        setShowFilterGoal(prev => !prev)
    }

    const handleApply = () => {
        setFilterGoalList(goalList?.filter((goal) => {
            return goalCheckedList?.find((checkedGoal) => {
                return checkedGoal.id === goal.id && checkedGoal.isChecked
            })
        }))
        const itemKey = isScholarship ? `scholarship_goal_checked_list` : `individual_goal_checked_list`
        localStorage.setItem(itemKey, JSON.stringify(goalCheckedList))

        setShowFilterGoal(false)
    }

    const handleCancel = () => {
        setShowFilterGoal(false)
    }

    const goalMenuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        document.addEventListener("mousedown", (event) => {
            if (goalMenuRef?.current && !goalMenuRef?.current.contains(event.target as Element)) {
                setShowFilterGoal(false);
            }
        })
    })

    return (
        <div className={(filterGoalList?.length > 0 && filterGoalList?.length < goalList?.length) ? "goal-menu-btn-container active" : "goal-menu-btn-container"} ref={goalMenuRef}>
            <button className="page-btn gap-dot5" onClick={handleClickFilterGoal}>
                <img src={filterIcon} alt="Filter icon" />
                <span>Filter</span>
            </button>
            {showFilterGoal && <FilterGoal goalCheckedList={goalCheckedList} setGoalCheckedList={setGoalCheckedList} filterGoalList={filterGoalList} handleApply={handleApply} handleCancel={handleCancel} />}
        </div>
    )
}

function FilterGoal({ goalCheckedList, setGoalCheckedList, filterGoalList, handleApply, handleCancel }: FilterGoalProps) {

    const handleReset = () => {
        setGoalCheckedList(goalCheckedList?.map((goal) => {
            return {
                ...goal,
                isChecked: true
            }
        }))
    }
    
    const handleClear = () => {
        setGoalCheckedList(goalCheckedList?.map((goal) => {
            return {
                ...goal,
                isChecked: false
            }
        }))
    }

    const handleChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, checked } = e.target
        setGoalCheckedList(goalCheckedList?.map((goal) => {
            if (id === `checkbox-goal-menu-${goal.id}`) {
                return {
                    ...goal,
                    isChecked: checked
                }
            }
            return goal
        }))
    }

    return (
        <div className="goal-menu filter">
            <div className="goal-menu-wrapper">
                <div className="goal-menu-title">
                    <h3>Filter by Goal</h3>
                    <p>Selected the goal to show a goal in goals list</p>
                </div>
                <div className="goal-menu-option-container">
                    {goalCheckedList?.map(({ goal, id, isChecked }, index) => (
                        <div className={"goal-menu-option flex gap-dot5" + (isChecked ? " active" : "")} key={id}>
                            <input type="checkbox" id={`checkbox-goal-menu-${id}`} name={goal} value={goal} onChange={handleChecked} checked={isChecked} />
                            <label htmlFor={`checkbox-goal-menu-${id}`}>{goal}</label>
                        </div>
                    ))}
                </div>
                <div className="h-line"></div>
                <div className="goal-menu-action-container flex-container ">
                    <div className="flex gap-dot25">
                        <button className="goal-menu-action" onClick={handleReset}>Reset</button>
                        <button className="goal-menu-action" onClick={handleClear}>Clear</button>
                    </div>
                    <div className="flex gap-dot25">
                        <button className="goal-menu-action" onClick={handleCancel}>Cancel</button>
                        <button className="goal-menu-action primary" onClick={handleApply}>Apply</button>
                    </div>
                </div>
            </div>
        </div>
    )
}